import { render, staticRenderFns } from "./HSADashboardItemSba.vue?vue&type=template&id=8faf615e&scoped=true&"
import script from "./HSADashboardItemSba.vue?vue&type=script&lang=js&"
export * from "./HSADashboardItemSba.vue?vue&type=script&lang=js&"
import style0 from "./HSADashboardItemSba.vue?vue&type=style&index=0&id=8faf615e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faf615e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
